import { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import smartComponentActions from "actions/smart-component-actions";
import TopRight from "components/source/navigation/top-right";
import { smartTopRightPropType } from "../../propTypes";

export class SmartTopRight extends Component {
  static propTypes = {
    fetchTopRightContent: PropTypes.func.isRequired,
    smartComponentState: PropTypes.shape({
      didFetchSmartTopRight: PropTypes.bool,
      smartTopRightCMS: smartTopRightPropType,
    }),
  };

  static defaultProps = {
    smartComponentState: {},
  };

  componentDidMount() {
    const { fetchTopRightContent, smartComponentState } = this.props;

    if (!smartComponentState?.didFetchSmartTopRight) {
      fetchTopRightContent();
    }
  }

  render() {
    const { smartComponentState } = this.props;
    if (!smartComponentState?.smartTopRightCMS) {
      return null;
    }

    return (
      <div className="mb-4 md:mb-0">
        <TopRight smartComponentState={smartComponentState} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  smartComponentState: state.smartComponentState,
});

const mapDispatchToProps = {
  fetchTopRightContent: smartComponentActions.getTopRightContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(SmartTopRight);
